import React from "react";
// UI Components
import { Row, Col, Typography } from "antd";
// Shared components
import PageTitle from "components/PageTitle";
// Utilities and hooks

// Styles
import styles from "./index.module.scss";

interface MainProps {
	title?: string;
	pageTitle?: string;
}
const { Title } = Typography;

const Main: React.FC<MainProps> = props => {
	return (
		<div className={styles["info-list"]}>
			<PageTitle title={props.pageTitle || props.title} />
			<div style={{ textAlign: "center", marginTop: 60, marginBottom: "30px" }}>
				<Title className="grad-blue-purple" style={{ fontSize: "2em" }} level={4}>
					{props.title}
				</Title>
			</div>
			<div className="container">
				<Row type="flex" justify="center">
					<Col lg={{ span: 12 }} md={{ span: 12 }} xs={{ span: 20 }} sm={{ span: 20 }}>
						{props.children}
					</Col>
				</Row>
			</div>
		</div>
	);
};

export default Main;
